<template>
  <div class="dialog_container">
    <el-dialog
      title="编辑车辆保险信息"
      :visible="dialogShow"
      width="436px"
      @close="dialogClose"
      top="20vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-form
          ref="redactCarTravelMilForm"
          class="add_staff_form"
          :model="redactCarTravelMilForm"
          label-width="130px"
          :rules="addRules"
        >
          <el-form-item label="登记日期：" prop="recordTimeStr">
            <el-date-picker
              v-model="redactCarTravelMilForm.recordTimeStr"
              type="date"
              placeholder="请选择登记日期"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="当月行驶里程：" prop="mileMonth">
            <el-input
              placeholder="请输入当月行驶里程"
              v-model="redactCarTravelMilForm.mileMonth"
            ></el-input>
          </el-form-item>
          <el-form-item label="累计行驶里程：" prop="mileAll">
            <el-input
              placeholder="请输入累计行驶里程"
              v-model="redactCarTravelMilForm.mileAll"
            ></el-input>
          </el-form-item>
          <el-form-item label="登记人员：">
            <el-input
              placeholder="请输入登记人员"
              v-model="redactCarTravelMilForm.createUserName"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button class="btn" @click="dialogClose">取 消</el-button>
          <el-button
            class="btn btn_ok"
            @click="confirm('redactCarTravelMilForm')"
            >保 存</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util.js";
export default {
  name: "",
  data() {
    return {
      redactCarTravelMilForm: {},
      username: "",
      addRules: {
        recordTimeStr: [
          { required: true, message: "请选择登记日期", trigger: "change" },
        ],
        mileMonth: [
          { required: true, message: "请输入当月行驶里程", trigger: "blur" },
        ],
        mileAll: [
          { required: true, message: "请输入累计行驶里程", trigger: "blur" },
        ],
      },
    };
  },
  components: {},
  props: {
    dialogShow: Boolean,
    dialogData: Object,
    carId:Number
  },
  watch: {
    dialogShow() {
      console.log("111",this.dialogData);
      this.redactCarTravelMilForm = {
        recordTimeStr: new Date(this.dialogData.recordTime),
        mileMonth: this.dialogData.mileMonth,
        mileAll: this.dialogData.mileAll,
        createUserName: this.dialogData.createUserName,
        id:this.dialogData.id,
        carId:this.carId
      };
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.redactCarTravelMilForm.recordTimeStr = dateTransition(
          this.redactCarTravelMilForm.recordTimeStr
        );
        this.$http.updateCarMile(this.redactCarTravelMilForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.redactCarTravelMilForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
/deep/.el-input__inner {
  width: 250px;
}
.hint_box {
  width: 100%;
  display: flex;
  .hint_placeholder {
    width: 100px;
  }
  .hint_text {
    width: 250px;
    font-size: 11px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9b9b9b;
  }
}
.limit {
  /deep/.el-form-item__content {
    display: flex;
  }
  /deep/.el-input__inner {
    width: 220px;
  }
}
.yuan_shangchuan {
  position: absolute;
  top: 0;
  right: 20px;
}
.baodan_img {
  /deep/.el-input__inner {
    width: 206px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/redactCarTravelMil.vue